import {FC, useEffect, useState} from "react";
import {Input, Modal, Select} from "antd";

const {Option} = Select;

interface OptionType {
    value: string;
    label: string;
}

export type ValueType = { value: string; secondValue?: string; };

interface EditModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: (value: ValueType) => void;
    title: string;
    initialValue: string | ValueType;
    inputType: 'input' | 'select' | 'double-select';
    options?: OptionType[];
    secondOptions?: OptionType[];
}

export const EditModal: FC<EditModalProps> = ({
                                                  isOpen,
                                                  onClose,
                                                  onSave,
                                                  title,
                                                  initialValue,
                                                  inputType,
                                                  options,
                                                  secondOptions
                                              }) => {
    const [value, setValue] = useState<string>('');
    const [secondValue, setSecondValue] = useState<string>('');

    useEffect(() => {
        if (typeof initialValue === 'string') {
            setValue(initialValue);
        } else if (initialValue) {
            setValue(initialValue.value);
            setSecondValue(initialValue.secondValue ?? '');
        }
    }, [initialValue]);

    const handleSave = () => {
        let saveValue: ValueType;

        if (inputType === 'double-select') {
            saveValue = {value, secondValue};
        } else if (inputType === 'select') {
            saveValue = {value};
        } else {
            saveValue = {value};
        }

        onSave(saveValue);
        onClose();
    };

    return (
        <Modal title={title} open={isOpen} onOk={handleSave} onCancel={onClose} okText="Speichern"
               cancelText="Abbrechen">
            {inputType === 'input' && (
                <Input size="large" value={value} onChange={(e) => setValue(e.target.value)}/>
            )}
            {inputType === 'select' && (
                <Select value={value} onChange={setValue} style={{width: '100%'}}>
                    {options?.map((option) => (
                        <Option key={option.value} value={option.value}>
                            {option.label}
                        </Option>
                    ))}
                </Select>
            )}
            {inputType === 'double-select' && (
                <>
                    <Select value={value} onChange={setValue} style={{width: '100%', marginBottom: '10px'}}>
                        {options?.map((option) => (
                            <Option key={option.value} value={option.value}>
                                {option.label}
                            </Option>
                        ))}
                    </Select>
                    <Select value={secondValue} onChange={setSecondValue} style={{width: '100%'}}>
                        {secondOptions?.map((option) => (
                            <Option key={option.value} value={option.value}>
                                {option.label}
                            </Option>
                        ))}
                    </Select>
                </>
            )}
        </Modal>
    );
};
